export const GET_RENTALS = 'app/Rentals/GET_RENTALS';
export const GET_RENTALS_AGGREGATIONS = 'app/Rentals/GET_RENTALS_AGGREGATIONS';
export const SET_START_AGGREGATIONS = 'app/Rentals/SET_START_AGGREGATIONS';
export const CLEAN_RENTALS_AGGREGATIONS = 'app/Rentals/CLEAN_RENTALS_AGGREGATIONS';
